export class GradeUniversitaire {
    constructor(
        public idGradeUniversitaire?: number,
        public typeGradeUniversitaire?: string,
        public libelle?: string,
        public nbUniteTemps?: number,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/grade-universitaire.model.ts